import { render } from "./MailingRegistryComponent.vue?vue&type=template&id=09ce688a&scoped=true"
import script from "./MailingRegistryComponent.vue?vue&type=script&lang=js"
export * from "./MailingRegistryComponent.vue?vue&type=script&lang=js"

import "./MailingRegistryComponent.vue?vue&type=style&index=0&id=09ce688a&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ce688a"]])

export default __exports__